import { DocumentListService } from './../../services/master-data.service';
import { Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from '../../services/master-data.service';
import { FormGroup, NgForm } from '@angular/forms';
import { DocumentModel, DocumentRoleModel, RoleModel } from './document-management.model';
import { CommonMessageService } from '../../services/common-message.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-document-management',
  templateUrl: './document-management.component.html',
  styleUrls: ['./document-management.component.css']
})
export class DocumentManagementComponent implements OnInit,OnDestroy{

  @Output() toggleSideNavEvent=new EventEmitter<boolean>();
  @Output() toggleDocumentNavEvent=new EventEmitter<boolean>();

  folderList;
  roleList;
  selectedRole;
  documentModel : DocumentModel;
  hideSaveButton=false;
  documentListPageDataFetch=false;
  folderUpdateData;
  folderSubscription:Subscription;
  deleteFolderSubscription:Subscription;
  showAddFolder=false;

  constructor(private masterDataService:MasterDataService,
    private commonMessageService:CommonMessageService,
    private modalService: NgbModal,
    public router: Router,
    private ngZone:NgZone,
    private documentListService:DocumentListService,
    ) { }

  ngOnInit(): void {
    var userRole=localStorage.getItem('userRole');
    // var userDesignation=localStorage.getItem('userDesignation');
    if(userRole=="Partner"){
     this.showAddFolder=true;
    }else{
      this.showAddFolder=false;
    }

    this.showOpenModal=false;
    this.documentModel=new DocumentModel();
    this.selectedRole="";
    this.loadFolders();
    this.deleteFolderSubscription=this.documentListService.getFolderIdForDelete().subscribe((folderId:any)=>{
     console.log('delete folder Id',folderId);
     this.deleteFolder(folderId);
    });

    this.folderSubscription=this.documentListService.getUpdatedFolder().subscribe((folderData:any)=>{
      console.log('update folder data in document management');
     this.folderUpdateData=folderData;
     this.updateFolder(this.folderUpdateData);
    })
  }

  ngOnDestroy(){
    this.folderSubscription.unsubscribe();
    this.deleteFolderSubscription.unsubscribe();
    }

  deleteFolder(folderId){
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.masterDataService.deleteFolder(folderId).subscribe((resp:any)=>{
          this.documentListService.clearDocument();
          this.commonMessageService.deleteMessage();
          this.loadFolders();
        });
      }
    })
  }

  updateFolder(folderData){
    this.masterDataService.updateFolder(folderData).subscribe((resp:any)=>{
      this.closeModel();
     this.commonMessageService.saveMessage();
     this.loadFolders();
     });
  }

  closeModel(){
    this.modalService.dismissAll();
  }

  loadFolders() {
    this.masterDataService.getFolderList().subscribe((resp:any) => {
      this.folderList = resp;
      console.log('folderList',this.folderList)
    });
  }

  modalChangeValue(event:{showOpenModal:boolean}){
   console.log('edit clickevent',event.showOpenModal);
   this.loadFolders();
   this.showOpenModal=event.showOpenModal;
  }

  toggleSideNav:boolean=false;
  toggleDocumentSideNav: boolean = false;
  goBackToMenuSideBar(){
    console.log('goBackToMenuSideBar');
    this.toggleSideNav=true;
    this.toggleSideNavEvent.emit(this.toggleSideNav);
    this.toggleDocumentSideNav=false;
    this.toggleDocumentNavEvent.emit(this.toggleDocumentSideNav);
    this.documentListService.clearDocument();
  }

  showOpenModal:boolean;
  onModalClick(){
    this.showOpenModal=true;
  }
}
